import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook, Instagram, Twitter } from 'lucide-react';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_print-hub-105/artifacts/wnqg6vfm_Printed%20lb.png';

export function Footer() {
  return (
    <footer className="bg-navy text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <img src={LOGO_URL} alt="Printed LB" className="h-12 w-auto mb-4 brightness-0 invert" />
            <p className="text-gray-300 text-sm leading-relaxed">
              Your trusted partner for design, printing, and delivery services in Lebanon.
            </p>
            <div className="flex gap-4 mt-6">
              <a href="#" className="text-gray-400 hover:text-mint transition-colors">
                <Facebook className="h-5 w-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-mint transition-colors">
                <Instagram className="h-5 w-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-mint transition-colors">
                <Twitter className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Products */}
          <div>
            <h4 className="font-heading font-semibold text-lg mb-4">Products</h4>
            <ul className="space-y-2">
              <li><Link to="/products?category=Advertising" className="text-gray-300 hover:text-mint text-sm transition-colors">Advertising</Link></li>
              <li><Link to="/products?category=Stationery & Cards" className="text-gray-300 hover:text-mint text-sm transition-colors">Stationery & Cards</Link></li>
              <li><Link to="/products?category=Packaging" className="text-gray-300 hover:text-mint text-sm transition-colors">Packaging</Link></li>
              <li><Link to="/products?category=Flexible Materials" className="text-gray-300 hover:text-mint text-sm transition-colors">Flexible Materials</Link></li>
              <li><Link to="/products?category=Outdoor Displays" className="text-gray-300 hover:text-mint text-sm transition-colors">Outdoor Displays</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-heading font-semibold text-lg mb-4">Services</h4>
            <ul className="space-y-2">
              <li><Link to="/custom-design" className="text-gray-300 hover:text-mint text-sm transition-colors">Custom Design</Link></li>
              <li><Link to="/quote" className="text-gray-300 hover:text-mint text-sm transition-colors">Get a Quote</Link></li>
              <li><Link to="/dashboard/orders" className="text-gray-300 hover:text-mint text-sm transition-colors">Track Order</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading font-semibold text-lg mb-4">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-3 text-gray-300 text-sm">
                <MapPin className="h-4 w-4 text-mint flex-shrink-0" />
                <span>Beirut, Lebanon</span>
              </li>
              <li className="flex items-center gap-3 text-gray-300 text-sm">
                <Phone className="h-4 w-4 text-mint flex-shrink-0" />
                <span>+961 1 234 567</span>
              </li>
              <li className="flex items-center gap-3 text-gray-300 text-sm">
                <Mail className="h-4 w-4 text-mint flex-shrink-0" />
                <span>info@printedlb.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-12 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm">
            © {new Date().getFullYear()} Printed LB. All rights reserved.
          </p>
          <div className="flex gap-6">
            <Link to="/privacy" className="text-gray-400 hover:text-mint text-sm transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="text-gray-400 hover:text-mint text-sm transition-colors">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
